import { createStore } from 'vuex'
import home from './module/home.js'
import station from './module/station.js'
export default createStore({
  modules: {
    home,
    station
  }
})